module.exports = __webpack_public_path__ + "static/media/16UNODC5.d77c7cf7.jpg";